<script>
    import {Route, Router} from "svelte-routing";
    import SubscriberTable from "../../components/Cards/Subscriber/SubscriberTable.svelte";
    import SubscriberForm from "../../components/Forms/Subscriber/SubscriberForm.svelte";
    export let location;
</script>

<Router url="subscribers">
    <Route component="{SubscriberTable}" />
    <Route path="table" component="{SubscriberTable}" />
    <Route path="create">
        <SubscriberForm isBackOffice={true} />
    </Route>
    <Route path="edit">
        <SubscriberForm isBackOffice={true} isEdit={true}/>
    </Route>
</Router>
